/**
 * Strip trailing incomplete <Gaia ...> (no /> yet) so we don't flash raw tags during streaming.
 */
export function stripIncompleteGaiaTag (markdown: string): string {
  if (!markdown) return markdown
  const lastOpen = markdown.lastIndexOf('<Gaia')
  if (lastOpen === -1) return markdown
  const after = markdown.slice(lastOpen)
  if (after.includes('/>')) return markdown
  return markdown.slice(0, lastOpen).trimEnd()
}

/**
 * Convert Gaia link tags in markdown to markdown links so OracleAgentMessage
 * (markdownToHtmlWithNewTabLinks) renders them.
 * - [text](<Gaia type="link" id="N" .../>) -> [text](/video/N)
 * - <Gaia type="link" id="N" text="T" /> -> [T](/video/N)
 * Note: The id in the tag must be a real content ID from the AI; we use it as /video/{id}.
 */
export function replaceGaiaTagsInMarkdown (markdown: string): string {
  if (!markdown) return markdown
  let result = markdown
  result = result.replace(
    /\(<Gaia\s+[^>]*?type=["']link["'][^>]*?id=["'](\d+)["'][^>]*?\/>\)/g,
    '(/video/$1)',
  )
  result = result.replace(
    /<Gaia\s+[^>]*?type=["']link["'][^>]*?id=["'](\d+)["'][^>]*?text=["']([^"']*)["'][^>]*?\/>/g,
    '[$2](/video/$1)',
  )
  result = result.replace(
    /<Gaia\s+[^>]*?text=["']([^"']*)["'][^>]*?type=["']link["'][^>]*?id=["'](\d+)["'][^>]*?\/>/g,
    '[$1](/video/$2)',
  )
  return result
}
